var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-nav-bar"},_vm._l((_vm.datas),function(item,index){return _c('a',{key:index,class:{ on: _vm.selectedId == item.Id },on:{"click":function($event){return _vm.select(item)}}},[_vm._v(_vm._s(item.Label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }